// extracted by mini-css-extract-plugin
module.exports = {"float":"styles_float__1RpBN"};